import React from 'react'
import { ToastBottomEnd } from '../../components/Toast';
import { toastSuccessCLipboardCopySuccessMessageConfig } from '../../../config/toastConfig';
import moment from 'moment';

const ListDiscussionBlock = ({numero, lastMessage, date, activeChat, id, changeChat, isread, channel}) => {
    
    const loadSociaIcon = () => {
        switch (channel) {
            case 'facebook':
                return "fa-facebook"
                break;
            case 'whatsapp':
                return "fa-whatsapp"
                break;
            case 'linkendin':
                return "fa-linkendin"
                break;
            default:
                break;
        }
    }

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text).then(() => {
            ToastBottomEnd.fire(toastSuccessCLipboardCopySuccessMessageConfig())
        }).catch(err => {
            console.error('Failed to copy: ', err);
        });
    }
    
    return (
        <li onClick={()=>changeChat(id)}>
            {/*LISTE DISCUSSION GAUCHE*/}
            <div className="kt-widget__items">
                <div className="kt-widget__item border p-3 rounded-lg">
                    {/*ICONE*/}
                    <i className={`fab ${loadSociaIcon()} fa-2x text-success`}></i>

                    {/*DISCUSSION*/}
                    <div className="kt-widget__info">
                        {/*NOM*/}
                        <div className="kt-widget__section">
                            <a
                                href={"#messageList"}
                                activeclassname="kt-menu__item--active"
                                aria-haspopup="true"
                                className="kt-widget__username"
                            >
                                {numero}

                                <span onClick={() => copyToClipboard(numero)} className="ml-2 text-decoration-none">
                                    <i className="fa fa-copy"></i>
                                </span>
                            </a>
                            {
                                activeChat && activeChat === id ? (
                                    <span className="kt-badge kt-badge--success kt-badge--dot">
                                        {" "}
                                    </span>   
                                ) : (
                                    !isread ? (
                                        <span className="kt-badge kt-badge--danger kt-badge--dot">
                                            {" "}
                                        </span>
                                    ) : ""
                                )
                            }
                        </div>

                        <span className="kt-widget__desc">
                            {lastMessage}
                        </span>
                        
                        <div className="kt-widget__action">
                            <span className="kt-widget__date">
                                {moment(date).format("ll")}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </li>
    )
}

export default ListDiscussionBlock